import {useEffect, useState} from "react";
import {error} from "../../../../@WUM/core/Elements/index";
import {ticketsystem2} from "../request/ticketsystem2";
import {
    pluginApiResponse,
    RecordsAllPaginated, TicketActivityRecord,
    ticketApiResponse,
    ticketApiType,
    WorkLogEntry
} from "../request/ticket.interface";
import {dashboardApiInterface} from "../request/dashboard.interface";
import {PrioApiType} from "../../../ticketsystem/API/request/Prio.interface";
import {checkLogin} from "../../../../@WUM/templates/default/Auth/service/AuthService";
import {LabelsApiType} from "../../../ticketsystem/API/request/Labels.interface";
import {ticket} from "../../../ticketsystem/API/request/ticket";
import {TimeTrackingFilterMode} from "../../Pages/components/TimeTrackingOverview/TimeTrackingCompleteOverviewTable";

export const ResponseAllTickets = (fetchData:any,archiv:any) => {
    const [posts, setPosts] = useState<ticketApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPosts(archiv)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [fetchData,archiv])

    return isError ? isError : posts
}

export const ResponseAllPlugin = () => {
    const [posts, setPosts] = useState<pluginApiResponse[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getAllPlugin()
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [])

    return isError ? isError : posts
}

export const ResponseSortedTickets = (
    fetchData:any,archiv:string,  searchString: string, limit: number, pageNumber:number, direction: "ASC" | "DESC", column: string
    ) => {
    const [posts, setPosts] = useState<ticketApiResponse>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getSortedTickets(archiv, searchString, limit, pageNumber, direction, column)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [fetchData, archiv, searchString, limit, pageNumber, direction, column])

    return isError ? isError : posts
}

export const ResponseTicketRecords = (
    id?: string,
    reload?: boolean,
) => {
    const [posts, setPosts] = useState<WorkLogEntry[]>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            if (id === undefined) return

            await ticketsystem2
                .getTicketRecords(id)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id, reload])

    return isError ? isError : posts
}

export const ResponseNotesGeneral = (
    id?: string,
    reload?: boolean,
) => {
    const [posts, setPosts] = useState<WorkLogEntry[]>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            if (id === undefined) return

            await ticketsystem2
                .getNotesGeneral(id)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id, reload])

    return isError ? isError : posts
}

export const ResponseNoteActivityReport = (
    id?: string,
    recordId?: string,
    reload?: boolean,
) => {
    const [posts, setPosts] = useState<TicketActivityRecord[]>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            if (id === undefined || recordId === undefined || recordId === "") return

            await ticketsystem2
                .getNotesActivityReport(id, recordId)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id, reload, recordId])

    return isError ? isError : posts
}

export const ResponseNoteRecordtime = (
    id?: string,
    recordId?: string,
    reload?: boolean,
) => {
    const [posts, setPosts] = useState<TicketActivityRecord[]>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            console.log(id)
            if (id === undefined || recordId === undefined || id === "undefined" || recordId === "undefined") return

            await ticketsystem2
                .getNotesRecordTime(id, recordId)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id, reload, recordId])

    return isError ? isError : posts
}

export const ResponseRecordAll = (
    filterMode: TimeTrackingFilterMode,
    limit: number,
    pageNumber: number,
    direction: "ASC" | "DESC",
    column: string,
    year?: string,
    day?: string,
    from?: string,
    to?: string,
    fetchData?: number
) => {
    const [posts, setPosts] = useState<RecordsAllPaginated>();
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        ;(async () => {
            try {
                let data: RecordsAllPaginated | undefined;

                if (filterMode === 'year') {
                    if (year === undefined || year === '') return;

                    data = await ticketsystem2.getAllTicketRecordsYear(
                        year,
                        limit,
                        pageNumber,
                        direction,
                        column
                    );
                }

                if (filterMode === 'singleDate') {
                    if (day === undefined || day === '') return;

                    data = await ticketsystem2.getAllTicketRecordsDay(
                        day,
                        limit,
                        pageNumber,
                        direction,
                        column
                    );
                }

                if (filterMode === 'dateRange') {
                    if (
                        from === undefined ||
                        from === '' ||
                        to === undefined ||
                        to === ''
                    ) {
                        return;
                    }

                    data = await ticketsystem2.getAllTicketRecordsBetween(
                        from,
                        to,
                        limit,
                        pageNumber,
                        direction,
                        column
                    );
                }

                if (data !== undefined) {
                    setPosts(data);
                    setIsError(false);
                }
            } catch (err) {
                error(err);
                setIsError(true);
            }
        })();
    }, [
        filterMode,
        year,
        day,
        from,
        to,
        fetchData,
        limit,
        pageNumber,
        direction,
        column
    ]);

    return isError ? isError : posts;
};

export const ResponseSingleTickets = (id:any,fetchData:any,setValue:any) => {
    const [posts, setPosts] = useState<ticketApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPostsSingle(id)
                .then((data) => {
                    setPosts(data)
                    setValue(data[0].description)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id,fetchData,setValue])

    return isError ? isError : posts
}

export const ResponseAllComment = (id:any,fetchData:any) => {
    const [posts, setPosts] = useState<ticketApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPostsSingleComment(id)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id,fetchData])

    return isError ? isError : posts
}
export const ResponseDashbaordTask = (id: any) => {
    const [posts, setPosts] = useState<dashboardApiInterface>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPostsTaskDashbaord(id)
                .then((data) => {
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id])

    return isError ? isError : posts
}
export const ResponseAllTemplate = (id: any,setCount?:any) => {
    const [posts, setPosts] = useState<PrioApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPostsTemplate()
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                    setCount(data.length)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id])

    return isError ? isError : posts
}
export const ResponseEmailSettings = (id: any,setCount?:any) => {
    const [posts, setPosts] = useState<PrioApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPostsEmailSettings()
                .then((data) => {
                    checkLogin(data)
                    /* @ts-ignore */
                    setPosts([data])
                    setCount(data.length)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id])

    return isError ? isError : posts
}


export const ResponseAllNotifictions = (id: any,setCount?:any) => {
    const [posts, setPosts] = useState<PrioApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPostsNotifications()
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                    setCount(data.length)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [id])

    return isError ? isError : posts
}
export const ResponseAllTriggerTicket = () => {
    const [posts, setPosts] = useState<LabelsApiType[]>([])
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await ticketsystem2
                .getPostsTrigger()
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()
    }, [])

    return isError ? isError : posts
}
